import {
  CustomerAttribute, CustomerAttributeGroup, CustomerAttributeSave, CustomerAttributeSaveItem,
} from '@src/customerAttributes/types.d.js';

export const mapCustomerAttributeTypeToSaveType = (customerAttribute : CustomerAttribute) : CustomerAttributeSave => {
  let customerAttributeItems : CustomerAttributeSaveItem[] = [];

  ['standard', 'extra'].forEach((customerAttributeGroup) => {
    if (!customerAttribute[customerAttributeGroup]) return;

    const items = (customerAttribute[customerAttributeGroup] as CustomerAttributeGroup).items.map((item) => {
      // All items that have granted=undefined must be send as granted=true to the backend.
      // The backend will check if any consent is set for a customer attribute and will set the correct
      // value to be saved in the DB.
      const granted = typeof item.granted === 'undefined' ? true : !!item.granted;

      return {
        id: item.id,
        granted,
      };
    });
    customerAttributeItems = [...customerAttributeItems, ...items];
  });

  const customerAttributeSaveData : CustomerAttributeSave = {
    type: 'customerAttribute',
    id: customerAttribute.id,
    items: customerAttributeItems,
  };

  return customerAttributeSaveData;
};
